import LinkAddressModal from './link-address-modal'

class AddressService {
    $lv;
    static storageKey = 'LINK_ADDRESS'                                                 //缓存localStorage的key
    static validTime = 1000 * 60 * 60 * 24 * 2                                         //有效时间
    address = undefined                                                                //省市县数据
    instance = null                                                                    //省市县模态对话框
    advances = {province: 3, city: 2, district: 1}                                     //省市县优先级
    constructor($lv) {
        this.$lv = $lv
    }

    /**
     * 从缓存中获取地址数据
     * @author  韦胜健
     * @date    2018/12/6 17:06
     */
    getFromStorage() {
        const {address, time} = JSON.parse(localStorage.getItem(AddressService.storageKey)) || {}
        return {address, time}
    }

    /**
     * 保存地址数据到缓存中
     * @author  韦胜健
     * @date    2018/12/6 17:06
     */
    saveToStorage(address) {
        localStorage.setItem(AddressService.storageKey, JSON.stringify({address, time: new Date().getTime()}))
    }

    /**
     * 获取所有地址数据
     * @author  韦胜健
     * @date    2018/12/3 10:00
     */
    async getAddress(context) {
        if (this.address === null) {
            while (!this.address) await this.$lv.Vue.$utils.delay(50)
        } else {
            this.address = null
            await this.reloadAddress(context)
        }
        return this.$lv.$utils.deepCopy(this.address)
    }

    /**
     * 重新请求地址数据
     * @author  韦胜健
     * @date    2018/12/3 09:55
     */
    async reloadAddress(context) {
        let {address, time} = this.getFromStorage()
        if (!address || !time || new Date().getTime() > ((time - 0) + AddressService.validTime)) {
            const url = `${LinkVue.prefixUrl}/alladdress/queryAllAddress`;
            // modify by yrf，若传入vue实例，则使用实例上的$http发起请求，适配多个后端的可能
			let $http = context ? context.$http : this.$lv.Vue.prototype.$http;
			let data = {};
			try {
				// 防止一个后端宕机影响另一个的使用
				data = await $http.post(url);
			} catch (e) {
				console.error(e);
				if ($http.otherHttpInstance) {
					console.warn('查询地址信息失败，切换请求地址重试。。。');
					data = await $http.otherHttpInstance.post(url);
				}
			}
            if (!!data.success && data.rows && data.rows.length > 0) {
                address = this.formatAddresses(data.rows)
                this.saveToStorage(address)
            }
        }
        this.address = address
        return address
    }

    /**
     * 格式化数据数据
     * @author  韦胜健
     * @date    2018/12/3 09:35
     */
    formatAddresses(array) {
        return array.reduce((ret, item) => {
            !!item.children && (item.children = this.formatAddresses(item.children))
            ret[item.name] = item.children || {}
            return ret
        }, {})
    }

    getInstance() {
        if (!this.instance) this.instance = this.$lv.newInstance(LinkAddressModal)
        return this.instance
    }

    async pick({
                   types,
                   param,
                   title,
				   mutiple,
				   isDefault,
                   onConfirm,
                   onCancel,
               }) {

        const highestType = types.reduce((ret, item) => {
            return this.advances[ret] > this.advances[item] ? ret : item
        }, '')
        if (highestType === 'city' && !param.province) {
            this.$lv.Vue.prototype.$dialog.show(LinkVue.$t('LinkForm.pickProvince'))
            return
        }
        if (highestType === 'district' && !param.city) {
            this.$lv.Vue.prototype.$dialog.show(LinkVue.$t('LinkForm.pickCity'))
            return
        }
        const instance = this.getInstance()
        instance.pick({
            types,
            param,
            title,
			mutiple,
			isDefault,
            onConfirm,
            onCancel
        })
    }
}

export {AddressService}
